import React from 'react';
import TextField from 'material-ui/TextField';
import Input from 'material-ui/Input';

const renderInput = ({ input, onChange, id, label, type, placeholder, className, disabled, mutedText, style, rows = 1, multiline = false, rowsMax = "", meta: { touched, error }, }) => (
  <React.Fragment>
    <TextField
      {...input}
      id={id || input.name}
      value={input.value}
      onChange={(event) => {input.onChange(event); if (onChange) onChange(event) }}
      label={placeholder || label}
      margin="normal"
      disabled={disabled}
      fullWidth
      error={touched && error ? true : false}
      type={type || 'text'}
      rows={rows}
      rowsMax={rowsMax}
      multiline={multiline}
      style={style}
    />
    {mutedText && <small className="form-text text-muted">{mutedText}</small>}
    {touched && error && <span className="invalid-feedback" style={{ display: 'inherit' }}>{error}</span>}
  </React.Fragment>
)

export default renderInput;



// WEBPACK FOOTER //
// ./src/components/InputUI/index.js